import React from "react";

const BulkEmptyState = ({
  title = "No items loaded",
  description = "Use a load action to pull items into the workspace.",
  children,
}) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-4">
    <h3 className="text-base font-bold text-[var(--heading-color)] mb-1">
      {title}
    </h3>
    <p className="text-sm text-[var(--description-color)] max-w-md mb-4">
      {description}
    </p>
    <div className="flex flex-wrap items-center justify-center gap-3">
      {children}
    </div>
  </div>
);

export default BulkEmptyState;
